<template>
  <div>
    <slot name="target" :show="() => banning = true"></slot>
    <ModalView v-model:active="banning">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between g-4">
          <h3 class="mb-0">{{ translate("ban") }}</h3>
          <ModalCloseButtonView @click="banning = false"/>
        </div>
      </template>
      <template v-slot:body>
        <PlayerBanFormView :community-id="communityId" :player-id="playerId" @ban="banning = false; $emit('ban')" @cancel="banning = false"/>
      </template>
    </ModalView>
  </div>
</template>

<script>
import {ModalView, ButtonView, ModalCloseButtonView} from "@/niftybit";
import PlayerBanFormView from "@/systems/modules/punishments/bans/PlayerBanFormView.vue";

export default {
  name: "ButtonBanPlayer",
  components: {ModalCloseButtonView, ButtonView, PlayerBanFormView, ModalView},
  props: {
    communityId: String,
    playerId: String
  },
  emits: ["ban", "update:active"],
  data() {
    return {
      banning: false
    }
  },
  watch: {
    banning() {
      this.$emit("update:active", this.banning);
    }
  }
}
</script>

<style scoped>

</style>